/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { HomeIcon } from "@heroicons/react/solid";

export interface IBreadcrumbItemProps {
  id: string;
  name: string;
  link: string;
}

export interface IBreadcrumbWidgetProps {
  items?: IBreadcrumbItemProps[];
}

export const BreadcrumbWidget = ({ items }: IBreadcrumbWidgetProps) => {
  const _renderItemsIf = () => {
    const _comp: any = [];
    if (items) {
      for (let i = 0; i < items?.length; ++i) {
        const item = items[i];
        _comp.push(
          <Breadcrumb.Item
            key={`breadcrumb-${item.id}-${i}`}
            href={item.link}
            active={i !== 0 && i === items?.length - 1}
          >
            {i === 0 ? (
              <HomeIcon className="icon icon-xs" />
            ) : (
              <>{item?.name}</>
            )}
          </Breadcrumb.Item>
        );
      }
    }
    return _comp;
  };
  return (
    <>
      <Breadcrumb
        className="d-md-inline-block"
        listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
      >
        {_renderItemsIf()}
      </Breadcrumb>
    </>
  );
};

BreadcrumbWidget.defaultProps = {
  items: [],
};
